import React from 'react'
import './Grid.css'
import GridItem from './GridItem'
import { useSelector } from 'react-redux'

const Grid = () => {

    const projectsData = useSelector((state) => state.projects)

    return (
        <div className="gallery">
            {
                projectsData.map((project) => <GridItem project={project} key={project.id} />)
            }
        </div>
    )
}

export default Grid